import React, { useEffect, useRef, useState } from 'react';
import { acceptMemeLayer, startStrategy } from '../../../services/StrategiesService';
import { processError } from '../../../services/ServiceUtils';
import { getErrorMessage } from '../../../utils/MessageUtils';

/**
 * Modal de aceite de risco da camada MEME (P5 item 3, PLANO-CAMADA-MEME item 3) — a ÚNICA
 * interação manual obrigatória pra ligar uma estratégia [Meme Momentum]. Aberto PROGRAMATICAMENTE
 * (não por clique num botão com data-bs-toggle): o start normal devolve 422 com
 * `memeGateRequired:true` e o chamador (MyStrategies.onStartClick) seta `props.data = { id }`, o
 * que dispara o useEffect abaixo a mostrar o modal via bootstrap.Modal (mesmo idioma do Dashboard).
 * Orçamento SEM valor pré-preenchido (exigência do plano — não empurrar um número "sugerido").
 * Cancelar não grava nada (o form fecha e o usuário segue sem a estratégia ligada).
 */
export default function MemeLayerAcceptModal(props) {
    const modalRef = useRef(null);
    const [budgetUsdt, setBudgetUsdt] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const id = props.data && props.data.id;

    useEffect(() => {
        if (!id) return;
        setBudgetUsdt('');
        setError('');
        setLoading(false);
        try {
            if (modalRef.current && window.bootstrap) {
                window.bootstrap.Modal.getOrCreateInstance(modalRef.current).show();
            }
        } catch (_) { /* graceful no-op — sem bootstrap carregado não trava a tela */ }
        // Dep é props.data (identidade do objeto), NÃO o id primitivo: cancelar e clicar "ligar" de
        // novo NA MESMA estratégia gera um data novo com o mesmo id — com dep no id o modal não
        // reabriria na segunda tentativa.
    }, [props.data]); // eslint-disable-line react-hooks/exhaustive-deps

    function hide() {
        try {
            if (modalRef.current && window.bootstrap) {
                const instance = window.bootstrap.Modal.getInstance(modalRef.current);
                if (instance) instance.hide();
            }
        } catch (_) { /* no-op */ }
    }

    function onSubmit(event) {
        event.preventDefault();
        const value = Number(budgetUsdt);
        if (!Number.isFinite(value) || value < 10 || value > 10000) {
            setError('Informe um orçamento entre 10 e 10.000 USDT.');
            return;
        }
        setLoading(true);
        setError('');
        acceptMemeLayer(value)
            .then(() => startStrategy(id))
            .then(() => {
                hide();
                if (props.onSuccess) props.onSuccess();
            })
            .catch(err => {
                setLoading(false);
                setError(getErrorMessage(processError(err)) || 'Falha ao ligar a camada MEME.');
            });
    }

    return (
        <div className="modal fade" id="modalMemeLayerAccept" ref={modalRef} tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <form onSubmit={onSubmit}>
                        <div className="modal-header">
                            <h5 className="modal-title">Ligar a camada MEME</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Fechar" disabled={loading}></button>
                        </div>
                        <div className="modal-body">
                            <div className="alert alert-warning">
                                A camada MEME acerta 30-40% das entradas; pode perder mais de 50% do
                                orçamento numa sequência ruim. O disjuntor corta as compras da camada
                                quando o dia acumula −25% do orçamento.
                            </div>
                            <div className="mb-2">
                                <label htmlFor="memeLayerBudgetInput" className="form-label">Orçamento da camada (USDT)</label>
                                <input
                                    id="memeLayerBudgetInput"
                                    type="number"
                                    className="form-control"
                                    min="10"
                                    max="10000"
                                    step="1"
                                    placeholder="ex.: 50"
                                    value={budgetUsdt}
                                    onChange={e => setBudgetUsdt(e.target.value)}
                                    disabled={loading}
                                    autoFocus
                                />
                                <div className="form-text">Entre 10 e 10.000 USDT — sem valor sugerido de propósito.</div>
                            </div>
                            {error && <div className="alert alert-danger mb-0">{error}</div>}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" disabled={loading}>Cancelar</button>
                            <button type="submit" className="btn btn-danger" disabled={loading || !budgetUsdt}>
                                {loading ? 'Ligando…' : 'Aceito o risco — salvar e ligar'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
